export default __webpack_public_path__ + "static/media/errorImage.f2dac3af.svg";